<template>
    <div v-if="isVisible" class="countdown-container week-range">
        {{ weekRange }}
    </div>
</template>
<script>
export default {
    name: 'WeekRangeCompo',
    props: {
        isVisible: {
            type: Boolean,
            default: true
        },
        // 0 = the running week, -1 = the week before it.
        offsetWeeks: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            weekRange: ''
        }
    },
    created() {
        this.weekRange = this.buildWeekRange();
    },
    methods: {
        buildWeekRange() {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            // CounterdownCompo counts down to Sunday 23:59:59, so a leaderboard
            // week runs Monday through Sunday. getDay() gives 0 for Sunday, so
            // shift it to make Monday day 0.
            const now = new Date();
            const daysSinceMonday = (now.getDay() + 6) % 7;

            const monday = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate() - daysSinceMonday + this.offsetWeeks * 7
            );
            const sunday = new Date(
                monday.getFullYear(),
                monday.getMonth(),
                monday.getDate() + 6
            );

            if (monday.getMonth() === sunday.getMonth()) {
                return `${monday.getDate()}–${sunday.getDate()} ${months[sunday.getMonth()]}`;
            }
            return `${monday.getDate()} ${months[monday.getMonth()]} – ${sunday.getDate()} ${months[sunday.getMonth()]}`;
        }
    }
}
</script>
